import SeoMetaData from "common/SeoMetaData"
import LoadingAiPage from "components/CreateAi/LoadingAiPage"

const LoadingAi = () => {
  const seo = {
    title: "יצירת תמונה ב-AI|loading",
    description: "חדש! יצירת תמונה של מקדונלד׳ס בהתאמה אישית",
    keywords: "יצירת תמונה ב-AI",
  }

  return (
    <>
      <SeoMetaData data={seo} />
      <LoadingAiPage />
    </>
  )
}

export default LoadingAi
